import React, { useState } from "react";
import mail from "../assets/images/mail.png";
import ContactForm from "../components/ContactForm";
import TranslatedText from "./TranslatedText";
import { Typography, Box } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import "../Styles/Contact.css";

const Contact = () => {
  const [messageList, setMessageList] = useState(
    JSON.parse(localStorage.getItem("contactForm")) || []
  );

  const addMessageToList = (newMessage) => {
    setMessageList((prevMessages) => [...prevMessages, newMessage]);
  };

  return (
    <Box className="activ-box" component="main" sx={{ p: 3 }}>
      <div className="contact-form">
        <Typography variant="h2" fontSize={40} marginTop={"11vh"} gutterBottom>
          <TranslatedText defaultText="Контакти" />
        </Typography>
        <div class="contact-img1">
          <img src={mail} alt="" style={{ width: "70px", height: "70px" }} />
        </div>

        <Typography variant="h5" fontSize={16} paddingTop={"2vh"} gutterBottom>
          <TranslatedText defaultText="Напишіть своє ім'я, e-mail, повідомлення та надішліть." />
        </Typography>
        <ContactForm addMessageToList={addMessageToList} />
      </div>

      <div className="links-wrap">
        <Typography
          variant="h3"
          sx={{
            fontSize: 23,
            paddingTop: 4,
            textAlign: "center",
            color: "#777878",
          }}
          gutterBottom
        >
          <TranslatedText defaultText="Посилання на контактні сторінки українських організацій у Норвегії:" />
        </Typography>

        <div className="link-container">
          <a
            className="contact-a"
            href="https://www.facebook.com/groups/5080342115346191"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Наша сторінка у Facebook" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
          <a
            className="contact-a"
            href="https://www.ukrainianembassy.no/ua/contact"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Контактна сторінка Посольства України в Королівстві Норвегія" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
          <a
            className="contact-a"
            href="https://www.facebook.com/UKRinNOR"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Контактна сторінка Facebook Посольства України в Королівстві Норвегія" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
          <a
            className="contact-a"
            href="https://https://www.facebook.com/DenUkrainskeForeningiNorge/"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Контактна сторінка Facebook Товариство українців в Норвегії" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
          <a
            className="contact-a"
            href="https://www.facebook.com/groups/204842916210134"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Контактна сторінка групи «Українці в Норвегії» у Facebook" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
          <a
            className="contact-a"
            href="https://www.facebook.com/groups/1288683384954748/?hoisted_section_header_type=recently_seen&multi_permalinks=1550010298822054"
            underline="hover"
            target="_blank"
            rel="noopener noreferrer"
          >
            {
              <h4 className="contact-link">
                <TranslatedText defaultText="Контактна сторінка групи «Українці у Ларвіку (Норвегія) - Допомога українським біженцям у Ларвіку» у Facebook" />
                <OpenInNewOutlinedIcon />
              </h4>
            }
          </a>
        </div>
      </div>
    </Box>
  );
};

export default Contact;
